import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Preloader from '../theme/Preloader';

const NotFound = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);
  const [isLoading, setIsLoading] = useState(true);

  // Simulate loading for the 404 page
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  // Auto-redirect back to previous page
  useEffect(() => {
    if (isLoading) return; // Don't start countdown while loading

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate(-1); // Go back to previous page
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isLoading, navigate]);

  // Show preloader while loading
  if (isLoading) {
    return <Preloader text="Loading..." size={70} fullScreen={true} />;
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      fontFamily: 'Arial, sans-serif',
      background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
      color: 'white',
      textAlign: 'center',
      padding: '20px',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Decorative background element */}
      <div style={{
        fontSize: '20rem',
        fontWeight: 'bold',
        color: 'rgba(198, 40, 40, 0.05)',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        userSelect: 'none',
        pointerEvents: 'none',
        zIndex: 0
      }}>
        404
      </div>

      {/* Main content */}
      <div style={{ position: 'relative', zIndex: 1 }}>
        <h1 style={{ 
          fontSize: '6rem', 
          margin: 0, 
          color: '#C62828',
          fontWeight: '900',
          textShadow: '0 4px 30px rgba(198, 40, 40, 0.3)'
        }}>
          404
        </h1>
        
        <h2 style={{ 
          fontSize: '2.5rem', 
          marginBottom: '10px',
          fontWeight: '700'
        }}>
          Page Not Found
        </h2>
        
        <p style={{ 
          fontSize: '1.2rem', 
          marginBottom: '5px', 
          color: '#94a3b8',
          maxWidth: '500px',
          lineHeight: '1.6'
        }}>
          Oops! The page you're looking for doesn't exist or has been moved.
        </p>
        
        <p style={{ 
          fontSize: '1.1rem', 
          marginBottom: '30px', 
          color: '#94a3b8'
        }}>
          Redirecting back in <strong style={{ color: '#C62828', fontSize: '1.3rem' }}>{countdown}</strong> seconds...
        </p>
        
        <div style={{ 
          display: 'flex', 
          gap: '15px', 
          flexWrap: 'wrap', 
          justifyContent: 'center' 
        }}>
          <button
            onClick={() => navigate(-1)}
            style={{
              padding: '14px 32px',
              backgroundColor: '#C62828',
              color: 'white',
              border: 'none',
              borderRadius: '10px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 20px rgba(198, 40, 40, 0.3)',
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#B71C1C';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 30px rgba(198, 40, 40, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#C62828';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 20px rgba(198, 40, 40, 0.3)';
            }}
          >
            Go Back Now
          </button>
          
          <button
            onClick={() => window.location.href = 'https://www.rmrdc.gov.ng/'}
            style={{
              padding: '14px 32px',
              backgroundColor: 'transparent',
              color: 'white',
              border: '2px solid #C62828',
              borderRadius: '10px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#C62828';
              e.target.style.color = 'white';
              e.target.style.transform = 'translateY(-2px)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = 'white';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            Visit our Website
          </button>
        </div>
        
        <p style={{ 
          marginTop: '50px', 
          color: '#475569', 
          fontSize: '0.9rem',
          borderTop: '1px solid rgba(255,255,255,0.05)',
          paddingTop: '20px',
          width: '100%',
          maxWidth: '300px',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}>
          © {new Date().getFullYear()} Elegante. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default NotFound;